export const CREATE_AGENDA = 'CREATE_AGENDA';
export const UPDATE_AGENDA = 'UPDATE_AGENDA';
export const DELETE_AGENDA = 'DELETE_AGENDA';
export const FETCH_AGENDA = 'FETCH_AGENDA';

export const CREATE_TASK = 'CREATE_TASK';
export const UPDATE_TASK = 'UPDATE_TASK';
export const DELETE_TASK = 'DELETE_TASK';
export const FETCH_TASK = 'FETCH_TASK';
export const CHECK_TASK = 'CHECK_TASK';

export const ADDTIME = 'ADDTIME';
export const MINUSTIME = 'MINUSTIME';